module.exports = {"player_position":"Position du joueur","enemy_position":"Position de l'ennemi"};